// Quote-wizard drafts in IndexedDB: the uploaded file (up to ~16 MB of
// base64) does not fit in localStorage. The file and the wizard choices are
// stored under two keys so typing in a field never rewrites the whole file.
// Every failure degrades to "no draft".
const DB_NAME = "machinepilot";
const STORE = "drafts";
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function run(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode);
    const req = fn(tx.objectStore(STORE));
    tx.oncomplete = () => resolve(req?.result);
    tx.onerror = () => reject(tx.error);
  });
}

const metaKey = (userId) => `quote-draft:${userId}`;
const fileKey = (userId) => `quote-draft:${userId}:file`;
const warn = (what, e) => console.warn(`[draft] ${what} failed:`, e?.message || e);

export async function loadQuoteDraft(userId) {
  try {
    const [meta, file] = await Promise.all([
      run("readonly", (s) => s.get(metaKey(userId))),
      run("readonly", (s) => s.get(fileKey(userId))),
    ]);
    if (!file?.imageBase64 || Date.now() - (file.savedAt || 0) > MAX_AGE_MS) return null;
    return { ...(meta || {}), ...file };
  } catch (e) {
    warn("load", e);
    return null;
  }
}

export const saveQuoteDraftFile = (userId, file) =>
  run("readwrite", (s) => s.put({ ...file, savedAt: Date.now() }, fileKey(userId))).catch((e) => warn("save file", e));

export const saveQuoteDraftMeta = (userId, meta) =>
  run("readwrite", (s) => s.put({ ...meta, savedAt: Date.now() }, metaKey(userId))).catch((e) => warn("save", e));

export const deleteQuoteDraft = (userId) =>
  run("readwrite", (s) => {
    s.delete(metaKey(userId));
    return s.delete(fileKey(userId));
  }).catch((e) => warn("delete", e));
